import React, { useState, useContext, useRef } from "react";
import CertificateTemplate from "../../../assets/images/Qwiz-Cert.png";
import html2canvas from "html2canvas";
import { IoMdUnlock, IoMdLock } from "react-icons/io";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const convertDate = (isoDate) => {
  if (!isoDate) return isoDate || "";

  let timestamp = Date.parse(isoDate);
  let jsDate = new Date(timestamp);
  let fDate = new Intl.DateTimeFormat("en-uk", {
    dateStyle: "short",
  });
  return fDate.format(jsDate);
};

const Certificate = ({ percentage }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const divRef = useRef(null);
  const storedData = JSON.parse(sessionStorage.getItem(`assignedCourses`));
  const currentUser = JSON.parse(sessionStorage.getItem("ccAuth"));

  const downloadCertificate = async () => {
    // Check if user profile is incomplete
    if (!currentUser?.name || currentUser?.name.trim() === "") {
      toast.warning("Please update your profile before downloading your certificate.");
      navigate("/qwiz/profile"); 
      return;
    }
    if (divRef.current) {
      try {
        setLoading(true); // Start loading

        // Add a fallback-friendly style for html2canvas
        divRef.current.classList.add("html2canvas-friendly");

        const originalDisplay = divRef.current.style.display;
        divRef.current.style.display = "block"; // Make visible for capture

        const options = {
          backgroundColor: null,
          scale: 2, // Ensure high quality
          useCORS: true, // Fix cross-origin image issues
          width: 1120,
          height: 794,
        };

        const canvas = await html2canvas(divRef.current, options);
        divRef.current.style.display = originalDisplay; // Restore display
        divRef.current.classList.remove("html2canvas-friendly");

        // Convert canvas to data URL
        const imgData = canvas.toDataURL("image/png");

        // Create a temporary download link
        const link = document.createElement("a");
        link.href = imgData;
        link.download = `${
          storedData?.learningPathInfo?.name || "certificate"
        }.png`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        toast.success("Certificate downloaded successfully!");
      } catch (error) {
        console.log(error, "error");
        toast.error(error.message || "Failed to download certificate.");
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <>
      <div className="border rounded-lg p-4 shadow-md mb-4  w-full bg-white transition duration-300 hover:shadow-lg">
        <h3
          className={`font-bold capitalize  text-lg   ${
            percentage !== 100 ? "text-gray-800" : ""
          }`}
        >
          Certificate
        </h3>
        <section className="w-full py-4 flex items-center justify-center">
          <button
            onClick={downloadCertificate}
            disabled={percentage !== 100}
            className={`mt-3 max-w-fit bg-[#61a641] flex items-center gap-4 font-normal text-sm text-white py-2 px-4 rounded-lg hover:bg-green-300 transition`}
          >
            {percentage === 100 ? (
              <IoMdUnlock className="w-4" />
            ) : (
              <IoMdLock className="w-4" />
            )}
            {loading ? "Downloading..." : "Download Certificate"}
          </button>
        </section>
      </div>

      <div
        ref={divRef}
        style={{
          width: "1120px", // Full A4 landscape width
          height: "794px", // Full A4 landscape height
          position: "absolute",
          left: "-9999px", // Hide from view
          backgroundImage: `url(${CertificateTemplate})`, // Use background image
          backgroundSize: "cover", // Ensure it covers the whole area
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
        id="course-certificate"
      >
        {/* Certificate Text Overlays */}
        <p className="font-semibold  text-4xl text-[#183157]  !bg-transparent   absolute  top-[45%] left-1/2 transform -translate-x-1/2 text-center w-full px-4">
          {currentUser?.name}
        </p>
        <p className="font-semibold text-2xl text-[#183157] !bg-transparent absolute top-[60.5%] left-1/2 transform -translate-x-1/2 text-center w-full px-4">
          {storedData?.learningPathInfo?.name}
        </p>

        <p className="font-normal text-center text-xl text-[#4F5E79] !bg-transparent absolute left-[81%] top-[85%]">
          {convertDate(
            storedData?.learningPathInfo?.learningPathCompletionDate
          )}
        </p>
      </div>
    </>
  );
};

export default Certificate;
